import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ListElement from "../header/ListElement";
import {addClass, removeClass} from "wipi-common/src/lib/util";
import "./LanguageSelector.scss"
import Text from "./Text";
import language from '../../assets/icons/language.svg'

export class LanguageSelector extends Component {

    constructor(props) {
        super(props)
        if (document.getElementById("root")) {
            document.getElementById("root").onclick = this.disableContextMenu;
        }
    }


    disableContextMenu = (e) => {
        if (e.target?.parentElement && e.target.parentElement.id!=='lang-logo') {
            document.getElementById("dropdown").style.display = 'none'
        }
        removeClass(document.getElementById('lang-logo'),"dpag-principal-lang-logo-active")
    }

    showDropdown = (e) => {
        e.stopPropagation()
        document.getElementById('dropdown').style.display = 'block'
        addClass(document.getElementById('lang-logo'),"dpag-principal-lang-logo-active")
    }

    chooseLanguage = (e, element) => {
        e.stopPropagation()
        document.getElementById('dropdown').style.display = 'none'
        this.props.changeLanguage(element)
        removeClass(document.getElementById('lang-logo'),"dpag-principal-lang-logo-active")
    }

    render = () => {
        return <button id="lang-logo" className="button-no-style d-flex align-items-center m-0 p-0"
                       onClick={this.showDropdown}
                       onKeyDown={(e) => {
                           if (e.key === 'Enter' || e.key === ' ') {
                               e.preventDefault();
                               this.showDropdown(e);
                           }
                       }}
                       tabIndex="0">
            <div className="padding-right-2">
                <svg id="languageSelector" width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg" data-test-id='e6j13c7k' aria-hidden="true">
                    <path d="M2.252 8C2.08416 8.6534 1.99949 9.32538 2 10C2 10.69 2.088 11.36 2.252
                12H5.1C4.96518 10.6701 4.96518 9.32993 5.1 8H2.252ZM3.07 6H5.416C5.682 4.783 6.066
                3.693 6.537 2.786C5.08518 3.48542 3.87722 4.60523 3.07 6ZM17.748 8H14.9C15.0348 9.32993
                15.0348 10.6701 14.9 12H17.748C18.0847 10.6879 18.0847 9.31208 17.748 8ZM16.93 6C16.1228
                4.60523 14.9148 3.48542 13.463 2.786C13.935 3.693 14.318 4.783 14.584 6H16.93ZM7.112
                8C7.03708 8.66403 6.99968 9.33176 7 10C7 10.685 7.038 11.355 7.112 12H12.888C13.0386
                10.6709 13.0386 9.32908 12.888 8H7.112ZM7.47 6H12.53C12.348 5.2483 12.0855 4.51841 11.747
                3.823C11.119 2.568 10.447 2 10 2C9.552 2 8.881 2.568 8.253 3.823C7.938 4.455 7.673 5.19
                7.47 6ZM3.07 14C3.87722 15.3948 5.08518 16.5146 6.537 17.214C6.065 16.307 5.682 15.217
                5.416 14H3.07ZM16.93 14H14.584C14.318 15.217 13.934 16.307 13.463 17.214C14.9148 16.5146
                16.1228 15.3948 16.93 14ZM7.47 14C7.673 14.81 7.938 15.545 8.253 16.177C8.881 17.432 9.553
                18 10 18C10.448 18 11.119 17.432 11.747 16.177C12.062 15.545 12.327 14.81 12.53 14H7.47ZM10
                20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20Z"
                    />
                </svg>
            </div>
            <p id="selectedLanguage" className="selectedLanguage" aria-label={this.props.selectedLanguage.title}>
                {this.props.selectedLanguage.title}</p>
            <ul id="dropdown" className="dropdown-menu">
                <li className="dropdown-header">
                    <img className="me-2" src={language} height="20"
                         alt="Language Selector Icon" data-test-id='e6h4c15ef'/>
                    {<Text k="languageSelector.language"/>}
                </li>
                {this.props.languageList?.map((e, index) => (
                    <ListElement key={`lang-${index}`} element={e}
                                 changeLanguage={this.chooseLanguage}
                                 index={index}
                                 selectedLanguage={this.props.selectedLanguage.value}
                                 languageCount={this.props.languageList.length}/>
                ))}
            </ul>
        </button>
    }
}

LanguageSelector.propTypes = {
    languageList: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        })).isRequired,
    changeLanguage: PropTypes.func.isRequired,
    selectedLanguage: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired
}

export default LanguageSelector